import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installResizeObserverLoopFix } from './utils/resizeObserverFix';

// Silence the benign "ResizeObserver loop" error (React Flow, auto-resize inputs)
// that otherwise pops the CRA dev overlay. Must run before any observer is created.
installResizeObserverLoopFix();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
